// extracted by mini-css-extract-plugin
export default {"main":"UserInfoPage_main__3QEMk","tabNavigation":"UserInfoPage_tabNavigation__Dg534","tabButton":"UserInfoPage_tabButton__MSuQB","activeTab":"UserInfoPage_activeTab__+uXh7"};